import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import refractor from 'refractor';
import visit from 'unist-util-visit';
export var FENCED_CLASS = 'remark-prismjs--fenced';
var attacher = function attacher() {
  return function (ast) {
    return visit(ast, 'code', visitor);
  };
  function visitor(node) {
    var _data$hProperties;
    var _node$data = node.data,
      data = _node$data === void 0 ? {} : _node$data,
      language = node.lang;
    if (!language) {
      return;
    }
    node.data = data;
    data.hChildren = refractor.highlight(node.value, language);
    data.hProperties = _objectSpread(_objectSpread({}, data.hProperties), {}, {
      language: language,
      className: ['prismjs'].concat(_toConsumableArray(((_data$hProperties = data.hProperties) === null || _data$hProperties === void 0 ? void 0 : _data$hProperties.className) || []), ["language-".concat(language), FENCED_CLASS])
    });
  }
};
export default attacher;